// SPDX-License-Identifier: AGPL-3.0-or-later

import {TemplateAcceptModal} from '@app/features/guild/components/modals/TemplateAcceptModal';
import {Logger} from '@app/features/platform/utils/AppLogger';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';

const logger = new Logger('TemplateCommands');

export async function openAcceptModal(code: string): Promise<void> {
	try {
		logger.debug(`Opening template accept modal for code ${code}`);
		ModalCommands.pushWithKey(
			modal(() => (
				<TemplateAcceptModal
					code={code}
					data-flx="guild.template-commands.open-accept-modal.template-accept-modal"
				/>
			)),
			`template-accept-${code}`,
		);
	} catch (error) {
		logger.error(`Failed to open template accept modal for code ${code}:`, error);
	}
}
